import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';

export const getState = state => state.metrics;

export const getMetrics = createSelector(
  getState,
  state => Immutable.asMutable(state.metrics),
);

export const getDurations = createSelector(
  getState,
  state => Immutable.asMutable(state.dates || []),
);

export const getServiceMetrics = createSelector(
  getState,
  state => Immutable.asMutable(state.serviceMetrics),
);

export const getLinkMetrics = createSelector(
  getState,
  state => Immutable.asMutable(state.linkMetrics),
);

export const getRecipientMetrics = createSelector(
  getState,
  state => Immutable.asMutable(state.recipientMetrics),
);

export const getError = createSelector(
  getState,
  state => state.error,
);

export const getIsFetching = createSelector(
  getState,
  state => state.isFetching,
);
